<div style="padding-left: 2%; padding-right: 2%;padding-top: 1%;">
  <mat-spinner class="center" *ngIf="loading"></mat-spinner>

  <!-- <pre>{{AbsDetail|json}}</pre> -->
  <div *ngIf="!loading">
      <div class="row" style="display: flex;">

        <p style="font-size: 23px;" class="float-left"><fa-icon [icon]="faPerson"  style=" cursor: pointer; color: #002D62;" class="fa-2x"></fa-icon> &nbsp;{{data.stu.studentId}}-{{data.stu.fullName}}</p>
      </div>


      <mat-tab-group>

        <mat-tab *ngIf="!data.stu.isElem">
          <ng-template mat-tab-label>
            <fa-icon [icon]="faCalendarDays"  style=" cursor: pointer; color: #002D62;" class="fa-1x"></fa-icon> &nbsp;&nbsp;
            <span>Student Schedule</span>
          </ng-template>

          <table class="table table-striped">
            <thead>
              <tr>
                <th>School Year</th>
                <th>Semester</th>
                <th>Start Period</th>
                <th>End Period</th>
                <th>Class</th>
                <th>Teacher</th>
                <th>Status</th>
                <th>Absences</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cls of AbsDetail.lstSchedule">
                <td>{{cls.schoolYear}}</td>
                <td>{{cls.semester}}</td>
                <td>{{cls.startPeriodOrder}}</td>
                <td>{{cls.endPeriodOrder}}</td>
                <td>{{cls.description}}</td>
                <td>{{cls.primaryTeacherFullName}}</td>
                <td>{{cls.classStatus}}</td>
                <td>{{cls.totalAbs}}</td>
              </tr>
            </tbody>
          </table>

        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <fa-icon [icon]="faPersonCircleExclamation"  style=" cursor: pointer; color: #002D62;" class="fa-1x"></fa-icon> &nbsp;&nbsp;
            <span>Absence Detail</span>
          </ng-template>
          <div *ngIf="ChartDisplay">
            <div *ngIf="AbsDetail">
              <fusioncharts
                width="100%"
                height="400"
                [type]="type"
                [dataFormat]="dataFormat"
                [dataSource]="DailyChartCurrent"
              >
              </fusioncharts>

              <br>
              <fusioncharts
              width="100%"
              height="400"
              [type]="type"
              [dataFormat]="dataFormat"
              [dataSource]="DailyChartPrevious"
            >
            </fusioncharts>
          </div>
        </div>
        </mat-tab>

      </mat-tab-group>
      <div mat-dialog-actions align="end" style="padding-top: 30px;">


        <button mat-button [mat-dialog-close]=""  cdkFocusInitial color="primary">Close</button>
      </div>
  </div>
</div>
